import { useIntl } from 'react-intl';

import { NoDataView } from '#components/shared/NoDataView.tsx';
import { TRACKING_CATEGORIES } from '#configuration/setup/googleAnalytics.ts';

import { config } from '../config.ts';

type NoActiveTourView = {
    canOpenTourInOrderCommunication: boolean;
};
export const NoActiveTourView = ({ canOpenTourInOrderCommunication }: NoActiveTourView) => {
    const intl = useIntl();

    return (
        <div className='flex align-items-center justify-content-center'>
            <NoDataView
                title={intl.formatMessage({ id: 'intl-msg:order-communication-web.no-tour-view.title' })}
                message={intl.formatMessage({
                    id: 'intl-msg:ordercom-communication-web.no-tour-view.label',
                })}
                link={
                    canOpenTourInOrderCommunication
                        ? {
                              href: `${config.orderCommunicationFmsUrl}/#/tours`,
                              label: 'Order Communication',
                              icon: 'new-window',
                          }
                        : undefined
                }
                trackingCategory={TRACKING_CATEGORIES.LIVEMONITOR}
                trackingLabel={'Show no active tour view'}
            />
        </div>
    );
};
